import React from "react";
import { Show, TextField, DateField, NumberField } from "react-admin";

export const StoragesShow = (props) => {
  return (
    <Show {...props}>
      <NumberField source="id" />
      <TextField source="storage" />
      <TextField source="freezer" />
      <TextField source="type" />
      <DateField
        source="createdAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <DateField
        source="updatedAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
    </Show>
  );
};
